import axios from "axios";
import { ContatoType } from "models/contato_type";
import { OrderType } from "models/order_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useState } from "react";

const useApprovedOrder = () => {
  const [list1, setList] = useState<OrderType[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [selectedOrder1, setSelectedOrder] = useState<OrderType>(null);
  const [show1, setShow] = useState(false);
  const [contatoCliente1, setContatoCliente] = useState<ContatoType>(null);
  const [contatoAgencia1, setContatoAgencia] = useState<ContatoType>(null);
  const [cabecalhoAprovado, setCabecalhoAprovado] = useState(false);
  const [itensAprovado, setItensAprovado] = useState(false);
  const [calculoAprovado, setCalculoAprovado] = useState(false);
  const [reload, setReload] = useState(false);

  const showModal1 = async (show: boolean, item: OrderType) => {
    if (show) {
      setSelectedOrder(item);
      if (item?.contatoAgencia) {
        await loadAgencia(item?.contatoAgencia);
      }
      if (item?.contatoCliente) {
        await loadClient(item?.contatoCliente);
      }
    }
    setShow(show);
  };

  const loadOrder = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/orcamento/aprovado/" + userData?.idEmpresa + "/3"
    );
    if (response.data) {
      setList(response.data);
    }
  };

  const loadContact = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/contato/" + id
    );
    if (response.data) {
      return response.data;
    }
  };

  const loadAgencia = async (id: string) => {
    const ca = await loadContact(id);
    if (ca) {
      setContatoAgencia(ca);
    }
  };
  const loadClient = async (id: string) => {
    const cl = await loadContact(id);
    if (cl) {
      setContatoCliente(cl);
    }
  };

  const approve = (type: string) => {
    switch (type) {
      case "1":
        setCabecalhoAprovado(true);
        break;

      case "2":
        setItensAprovado(true);
        break;

      case "3":
        setCalculoAprovado(true);
        break;

      default:
        break;
    }
  };

  const reprove = (type: string) => {
    showModal1(false, selectedOrder1);
    switch (type) {
      case "1":
        setCabecalhoAprovado(false);
        break;
      case "2":
        setItensAprovado(false);
        break;
      case "3":
        setCalculoAprovado(false);
        break;

      default:
        break;
    }
  }

  const refresh = () => {
    setReload(!reload);
  }

  const updateStatusOrder = async () => {
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/projeto/orcamento/status/" + selectedOrder1.id + "/4"

    );
    if (response.data) {
      showModal1(false, selectedOrder1);
      refresh();
    }

  }

  useEffect(() => {
    const loadData = async () => {
      await loadOrder();
    };

    loadData();
  }, [reload]);

  return {
    list1,
    usuario,
    showModal1,
    show1,
    selectedOrder1,
    contatoCliente1,
    contatoAgencia1,
    approve,
    reprove,
    cabecalhoAprovado,
    calculoAprovado,
    itensAprovado,
    refresh,
    updateStatusOrder
  };
};
export default useApprovedOrder;
